export default __webpack_public_path__ + "static/illustration-business.url-93a44719f90d4e16d1d032ccd4dc26f8.svg";